import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import Table from "../../components/Table/Table";
import moment from "moment/moment";
import Alert from "react-s-alert";

class CustomaryPriceModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            modal: false,
            content: [],
            total: 0,
            loading: false,
            page: 0,
            size: 10,
            paymentInfo:{}
        };
        this.fetchData = this.fetchData.bind(this);
        this.payment = this.payment.bind(this);
        this.paymentState = this.paymentState.bind(this);
    }

    componentWillMount() {
        this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size);
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '';
        let params = {
            url: '/connector/fetchAllCompanyPaymentByCustomer?page=' + page + '&size=' + size + sortStr,
            method: "post"
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                });
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    payment(row) {
        let merchantOkUrl = window.location.origin;
        let self = this;
        let {recordId,merchantOid, paymentStatus} = row;
        if (merchantOid !== null && paymentStatus !== 3) {
            setTimeout(function () {
                self.setState({loading: false});
                window.location.href = self.props.paytrDomain + "/external/" + merchantOid;
            }, 100);
        } else {
            let params = {
                url: "/connector/setErpPaymentInfo",
                method: "post",
                data: {
                    recordId,
                    merchantOkUrl
                }
            };
            this.setState({loading: true});
            request(params)
                .then(function (response) {
                    let paymentData = response.data;
                    Alert.success("Sepete eklendi.", {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 2000,
                        html: false
                    });
                    setTimeout(function () {
                        self.setState({loading: false});
                        window.location.href = self.props.paytrDomain + "/external/" + paymentData.merchantOid;
                    }, 100);
                }).catch(function (error) {
                self.setState({loading: false});
                showAxiosError(error);
            });
        }
    }

    paymentState(data) {
        let htmlResult = "";
        if (data.paymentStatus === 0) {
            htmlResult = "Ödeme Bekleniyor";
        } else if (data.paymentStatus === 2) {
            htmlResult = "Ödeme Başarılı";
        } else if (data.paymentStatus === 3) {
            htmlResult = "Ödeme Başarısız";
        } else {
            htmlResult = "";
        }
        return (
            <span>
        <p style={{margin: 0}}
           className={data.paymentStatus === 2 ? "text-success" : (data.paymentStatus === 3 ? "text-danger" : ((data.paymentStatus === 1 || data.paymentStatus === 0) ? "text-info" : "text-secondary"))}>
				{htmlResult}
        </p>
        </span>
        );
    }

    render() {
        let content = this.state.content;
        let columns = [
            {
                Header: "Şube Fiyatı",
                title: 'Şube Fiyatı',
                accessor: "branchPrice",
                sortable: false,
                width: "11%",
            },
            {
                Header: "Şube Sayısı",
                title: 'Şube Sayısı',
                accessor: "branchCount",
                sortable: false,
                width: "11%",
            },
            {
                Header: "Kurulum Fiyatı",
                title: 'Kurulum Fiyatı',
                accessor: "installmentPrice",
                sortable: false,
                width: "11%",
                Cell: row => (
                    <label>{row.installmentPrice} ₺ <br/></label>)
            },
            {
                Header: "Toplam Fiyatı",
                title: 'Toplam Fiyatı',
                accessor: "totalPrice",
                sortable: false,
                width: "11%",
                Cell: row => (
                    <label>{row.totalPrice} ₺ <br/></label>)
            },
            {
                Header: "Ödeme Durumu",
                title: 'Ödeme Durumu',
                accessor: "",
                sortable: false,
                width: "13%",
                Cell: row => (
                    <label>{this.paymentState(row)}</label>
                )
            },
            {
                Header: "Başlangıç Tarihi",
                title: 'Başlangıç Tarihi',
                accessor: "startDate",
                sortable: false,
                width: "12%",
                Cell: row => (
                    <div>{moment(row.startDate).isValid() ? moment(row.startDate).format("DD-MM-YYYY") : ''}<br/></div>)
            },
            {
                Header: "Bitiş Tarihi",
                title: 'Bitiş Tarihi',
                accessor: "expireDate",
                sortable: false,
                width: "12%",
                Cell: row => (
                    <div>{moment(row.expireDate).isValid() ? moment(row.expireDate).format("DD-MM-YYYY") : ''}<br/>
                    </div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                width: "10%",
                Cell: row => (
                    <div>
                        <div>
                            {row.paymentStatus !== 2  ?
                                <>
                                    <button type="button" onClick={() => this.payment(row)} rel="tooltip"
                                            className="Btn btn-icon" title="Ödeme Yap"
                                            style={{background: 'rgb(52, 216, 103)'}}>
                                        <i className="fa fa-credit-card"/>
                                    </button>
                                </>
                                :
                                <p>-</p>
                            }
                        </div>
                    </div>
                )
            }];
        return (
            <div>
                <Modal isOpen={this.props.modal} size='lg'>
                    <ModalHeader toggle={() => this.props.toggle()}>Konnektör Ücret İşlemleri</ModalHeader>
                    <ModalBody style={{paddingTop: '4px'}}>
                        <div className="col-sm-12" style={{marginTop: "30px"}}>
                            <div className="card-header ">
                                <Table columns={columns}
                                       content={content}
                                       total={this.state.total}
                                       page={this.state.page}
                                       size={this.state.size}
                                       loading={this.state.loading}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={this.fetchData}
                                       manual={this.state.manual}
                                />
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

}

export default CustomaryPriceModal;